import "../../../styles/actionbar/item.css";

export { Fluffer };
const Fluffer = (props: { order?: boolean }) => {
  return <div className={"actionBarItem fluffer"} />;
};
